import {ComponentType, Overlay} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {Injectable, InjectionToken, Injector} from '@angular/core';

import {DialogRef} from '../shared/ui-kits/dialog/dialog-ref';

export const DIALOG_DATA = new InjectionToken<any>('DIALOG_DATA');

interface DialogConfig {
  data?: any;
  settings: any;
}

/**
 * Service that creates dialog window (popup)
 */
@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private overlay: Overlay, private injector: Injector) {}

  /**
   * Open a custom component in an overlay
   *
   * @param component component that need to be opened
   * @param config object with DialogConfig type
   * @returns
   */
  open<T>(component: ComponentType<T>, config?: DialogConfig): DialogRef {
    /**
     * Globally centered position strategy
     */
    const positionStrategy = this.overlay
      .position()
      .global()
      .centerHorizontally()
      .centerVertically();

    const scrollStrategy = this.overlay.scrollStrategies.block();
    /**
     * Create the overlay with customizable options
     */
    const overlayRef = this.overlay.create({
      positionStrategy,
      hasBackdrop: true,
      backdropClass: 'overlay-backdrop',
      panelClass: 'overlay-panel',
      width: config?.settings.width,
      height: config?.settings.height,
      scrollStrategy,
    });

    /**
     * Create dialogRef to return
     */
    const dialogRef = new DialogRef(overlayRef);

    /**
     * Create injector to be able to reference the DialogRef from within the component
     */
    const injector = Injector.create({
      parent: this.injector,
      providers: [
        {provide: DialogRef, useValue: dialogRef},
        {provide: DIALOG_DATA, useValue: config?.data},
      ],
    });

    /**
     * Attach component portal to the overlay
     */
    const portal = new ComponentPortal(component, null, injector);
    overlayRef.attach(portal);

    return dialogRef;
  }
}
